var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.7893 0L19.1817 2.35363L6.46825 14.8609L0 8.49756L2.40602 6.14724L6.46848 10.1438L16.7893 0Z"}));
}

Checkmark.defaultProps = {"className":"checkmark","viewBox":"0 0 20 15"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
